export class MissingClaimError {
  type = 'MissingClaimError';

  constructor() {}
}
